import { render, staticRenderFns } from "./FakeLink.vue?vue&type=template&id=046c10f2&scoped=true"
import script from "./FakeLink.vue?vue&type=script&lang=js"
export * from "./FakeLink.vue?vue&type=script&lang=js"
import style0 from "./FakeLink.vue?vue&type=style&index=0&id=046c10f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c10f2",
  null
  
)

export default component.exports